import { UploadFilesHelper } from "../helpers/upload-files.helper";

export default {
  methods: {
    getAllowedImageFileTypes() {
      return UploadFilesHelper.getAllowedImageFileTypes();
    }
  }
}